<script>
  import { createEventDispatcher } from 'svelte';
  import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Button,
    Spinner
  } from "sveltestrap";

  import axios from "axios";

  const dispatch = createEventDispatcher();

  export let propertyId;

  let open = false;
  let toggle = () => (open = !open);
  let saving = false;
  let isFormValid = false;

  let floors = [];
  let appendFloorCount = 1;
  let newFloor = {
    number: '',
    order: 0,
    notes: '',
  };

  export function openModal(initialOrder) {
    open = true;
    floors = [];
    appendFloorCount = 1;
    appendFloor(initialOrder);
  }

  function appendFloor(initialOrder = 1) {
    const sortedOrders = floors.map(e => e.order).sort((a, b) => a - b);
    const startingOrder = sortedOrders.length > 0
      ? sortedOrders[sortedOrders.length - 1] + 1
      : initialOrder;

    const newFloors = [];
    for (let i = 0; i < appendFloorCount; i++) {
      floors.push({
        number: '',
        order: startingOrder + i,
        notes: '',
      });
    }

    floors = floors;
    newFloor = {
      number: '',
      order: startingOrder + appendFloorCount,
      notes: '',
    };

    validateForm();
  }

  function removeFloor(idx) {
    floors.splice(idx, 1);
    floors = floors;

    validateForm();
  }

  function AddFloors() {
    saving = true;

    var formData = new FormData();
    for (let i = 0; i < floors.length; i++) {
      const floor = floors[i];

      formData.append(`floors[${i}].PropertyId`, propertyId);
      formData.append(`floors[${i}].Completed`, false);
      formData.append(`floors[${i}].Notes`, floor.notes);
      formData.append(`floors[${i}].FloorOrder`, floor.order);
      formData.append(`floors[${i}].FloorName`, floor.number);
      formData.append(`floors[${i}].FloorLabel`, floor.number);
    }

    axios({
      method: "post",
      url: "/jobboardapi/AddMultipleFloor",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then(res => {
        floors = [];
        toggle();
      })
      .then(_ => dispatch('completed'))
      .catch(console.warn)
      .finally(_ => saving = false);
  }

  function validateForm() {
    isFormValid = floors.length > 0 && floors.every(e => !!e.number);
  }

</script>

<style>
  input {
    width: 100%;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
  }

  input[required]:invalid {
    border-color: red;
  }

  .row-container {
    margin-bottom: 10px;
  }

  .floors {
    display: flex;
    flex-direction: column;
  }

  .floor-form {
    display: flex;
    gap: 0.5rem;
  }

  .floor-form-controls {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0.5rem;
    flex-grow: 1;
  }

  .floor-form-controls textarea {
    grid-column: span 2;
  }

  .floor-form button {
    align-self: start;
    flex-grow: 0;
  }

  .floors > div:not(last-child) {
    border-top: 1px gray;
    padding-top: 0.5rem;
  }

  .actions {
    display: flex;
    gap: 0.5rem;
  }

  .actions > input[type=number] {
    width: 7rem;
  }

</style>

<Modal isOpen={open} {toggle}>
  <ModalHeader {toggle}>Add Floors</ModalHeader>
  <ModalBody>
    <div class="floors">
      {#each floors as floor, idx}
        <div class="floor-form">
          <div class="floor-form-controls">
            <input type="text" class="form-control" placeholder="Floor Number" required
                   bind:value={floor.number}
                   on:change={validateForm} />
            <input type="number" class="form-control" bind:value={floor.order} placeholder="Order" required />
            <textarea class="form-control" bind:value={floor.notes} placeholder="Notes"></textarea>
          </div>
          <button class="btn btn-danger" on:click={() => removeFloor(idx)}>
            <i class="fas fa-trash"></i>
          </button>
        </div>
      {/each}
      <div class="actions">
        <Button color="secondary" on:click={appendFloor}>Add Floor</Button>
        <input type="number" class="form-control" bind:value={appendFloorCount} placeholder="Amount" min="1" />
      </div>
    </div>
  </ModalBody>
  <ModalFooter>
    {#if saving}
      <Button color="primary" disabled>
        <Spinner size="sm" />
        Saving
      </Button>
    {:else if !isFormValid}
      <Button color="primary" disabled>Save</Button>
    {:else}
      <Button color="primary" on:click={AddFloors}>Save</Button>
    {/if}
    <Button color="secondary" on:click={toggle}>Cancel</Button>
  </ModalFooter>
</Modal>
